<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title><h1>Loan Purposes</h1></v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field> -->
      <v-spacer></v-spacer>
      <!-- <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="editedItem.title"
                    label="Fund Purpose Name"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-toolbar>
    <br />
    <v-card
      class="pa-4"
      style="max-width: 500px; margin: 10px auto"
      id="loan-purposes"
    >
      <v-treeview
        open-on-click
        :items="indexData"
        item-text="title"
        item-children="descendants"
      >
        <template v-slot:prepend="{ item }">
          <h3 v-if="item.descendants.length == 0">{{ item.id }}.</h3>
        </template>
        <template v-slot:append="{ item }">
          <v-icon color="primary" title="Add" @click="openAddNew(item)">
            add
          </v-icon>
          <v-icon
            color="primary"
            title="Edit"
            small
            @click="openUpdatePurposeDialog(item)"
            class="ml-2"
          >
            edit
          </v-icon>
          <v-icon
            color="primary"
            title="Delete"
            small
            @click="deletePurpose(item.id)"
            class="ml-2"
          >
            delete
          </v-icon>
        </template>
      </v-treeview>
      <v-icon color="primary" large @click="openAddNew">add</v-icon>
      <v-dialog v-model="addNewPurposeDialog" width="500">
        <v-card>
          <h2 class="primary px-4 py-2" v-if="parent.id" style="color: #fff">
            {{ parent.title }}
          </h2>
          <div class="px-4 py-4">
            <v-text-field label="New Purpose" v-model="newPurpose" />
            <v-btn
              color="primary mx-0"
              @click="addNewPurpose"
              :loading="loading"
            >
              Add
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="UpdatePurposeDialog" width="500">
        <v-card>
          <!-- <h2 class="primary px-4 py-2" v-if="parent.id" style="color: #fff">
            {{ parent.title }}
          </h2> -->
          <div class="px-4 py-4">
            <v-text-field label="Update Purpose" v-model="updatedPurpose" />
            <v-btn
              color="primary mx-0"
              @click="updatePurpose"
              :loading="loading"
            >
              Update
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      dialog: false,
      search: "",
      apiUrl: "loan-purposes/all",
      headers: [
        {
          text: "Loan Purpose Title",
          align: "center",
          sortable: false,
          value: "name",
        },
        { text: "Actions", align: "center", value: "actions" },
      ],
      editedIndex: -1,
      editedItem: {
        title: "",
      },
      defaultItem: {
        title: "",
      },
      parent: {
        title: "",
        parent_id: null,
      },
      addNewPurposeDialog: false,
      newPurpose: "",
      loading: false,
      UpdatePurposeDialog: false,
      updatedPurpose: "",
      selectedId: null,
      parentId: null,
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
        "investorAgreement",
        "investeeAgreement",
        "userImage",
        "docImage",
      ]),
      formTitle() {
        return this.editedIndex === -1
          ? "New Loan Purpose"
          : "Edit Loan Purpose";
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.$store.dispatch("setIndexData", [this.apiUrl]);
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      editItem(item) {
        this.editedIndex = this.indexData.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      deleteItem(item) {
        const index = this.indexData.indexOf(item);
        confirm("Are you sure you want to delete this item?") &&
          this.indexData.splice(index, 1);
        this.$store.dispatch("delete", [this.apiUrl, item.id]);
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      async save() {
        // if (this.editedIndex > -1) {
        //   this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
        // } else {
        await this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
        // }
        this.close();
      },

      openAddNew(parent = null) {
        this.newPurpose = "";
        this.parent = parent;
        this.addNewPurposeDialog = true;
      },

      async addNewPurpose() {
        this.loading = true;
        await this.$store.dispatch("store", [
          "loan-purposes",
          {
            title: this.newPurpose,
            parent_id: this.parent.id || null,
          },
        ]);
        this.loading = false;
        this.addNewPurposeDialog = false;
      },
      openUpdatePurposeDialog(item) {
        this.selectedId = item.id;
        this.parentId = item.parent_id;
        this.updatedPurpose = item.title;
        this.UpdatePurposeDialog = true;
      },
      async updatePurpose() {
        // return console.log("clicked");

        this.loading = true;
        try {
          await this.$store.dispatch("updateLoanPurpose", {
            title: this.updatedPurpose,
            parent_id: this.parentId,
            id: this.selectedId,
          });
          this.loading = false;
          this.UpdatePurposeDialog = false;
        } catch (e) {
          // console.log(e);
        }
      },

      async deletePurpose(id) {
        const getConfirmation = confirm(
          "Are you sure you want to delete this item?"
        );
        if (getConfirmation) {
          this.loading = true;
          try {
            await this.$store.dispatch("deleteLoanPurpose", id);
          } catch (e) {
            // console.log(e);
          }
          this.loading = false;
          this.UpdatePurposeDialog = false;
        }
      },
    },
  };
</script>
<style scoped>
  /* ::v-deep .v-treeview-node__label {
    flex-grow: 0 !important;
    margin-right: 40px;
  } */
  ::v-deep .v-treeview-node__content > i {
    display: none;
  }
  ::v-deep .v-treeview-node__content {
    padding: 3px;
  }
  ::v-deep .v-treeview-node__content:hover {
    background: #eee;
  }
  ::v-deep .v-treeview-node__content:hover > i {
    display: block;
  }
</style>
